import { vmodule, VueModule } from '@niknevis/vue-modules'

import compositionApi from './boot/composition-api'
import quasar from './boot/quasar'
import inertia from './boot/inertia'
import i18n from './boot/i18n'
import plugins from './boot/plugins'
import collect from '@/modules/common/core/boot/collect'
import loop from '@/modules/common/core/boot/loop'
import icons from '@/modules/common/core/boot/icons'
import validations from '@/modules/common/core/boot/validations'

@vmodule()
export default class CoreModule extends VueModule {
  readonly name = 'CoreModule'

  bootfiles = [
    compositionApi,
    inertia,
    quasar,
    i18n,
    plugins,
    collect,
    loop,
    icons,
    validations
  ]
}
